const TUIChat = {
  '查看内容': '内容を查看する',
  '立即填写': 'すぐに填写する',
  '已提交': '既に提交されました',
  '不能为空': '空にできません',
  '提交': '提交する',
  '撤回': '撤回する',
  '删除': '削除する',
  '复制': 'コピーする',
  '重新发送': '再送信する',
  '转发': '転送する',
  '引用': '引用する',
  '打开': '開く',
  '已读': '既読',
  '未读': '未読',
  '人已读': '人が既読',
  '人未读': '人が未読',
  '人关闭阅读状态': '人が阅读状态を关闭する',
  '全部已读': '全部既読',
  '消息详情': '消息の詳細',
  '关闭阅读状态': '阅读状态を关闭する',
  '您': 'あなた',
  '撤回了一条消息': '一条の消息を撤回しました',
  '重新编辑': '再編集する',
  '我': '私',
  '自定义消息': 'カスタムメッセージ',
  '查看更多': 'もっと見る',
  '确认重发该消息？': 'この消息を再送信しますか？',
  '取消': 'キャンセル',
  '确定': '確定',
  '转发给': '～に転送する',
  '请输入消息': 'メッセージを入力してください',
  '描述': '説明',
  '经度': '経度',
  '纬度': '緯度',
  '图片': '[画像]',
  '语音': '[音声]',
  '视频': '[動画]',
  '表情': '[表情]',
  '文件': '[ファイル]',
  '自定义': '[カスタムメッセージ]',
  '管理员开启全员禁言': '管理者が全员禁言を开启する',
  '您已被管理员禁言': 'あなたは管理者によって禁言されました',
  '按Enter发送': 'Enterを押して送信する',
  '单击下载': 'クリックしてダウンロード',
  '下载': 'ダウンロード',
  '该消息不存在': 'その消息は存在しません',
  '无法定位到原消息': '元の消息を特定できません',
  '对方正在输入': '相手が入力中...',
  '回到最新位置': '',
  '条新消息': '件の新しい消息',
  '点此投诉': 'ここをクリックして投诉する',
  '语音通话': '音声通話',
  '视频通话': 'ビデオ通話',
  '发起群语音': '群音声を发起する',
  '发起群视频': '群ビデオを发起する',
  '已接听': '応答済み',
  '拒绝通话': '通話を拒否する',
  '无应答': '応答なし',
  '取消通话': '通話をキャンセルする',
  '发起通话': '通話を发起する',
  '结束群聊': '群聊を終了する',
  '通话时长': '通話時間',
  '欢迎使用TUICallKit': '騰訊雲音视频通話コンポーネントTUICallKitのご使用を歓迎します',
  '检测到您暂未集成TUICallKit，无法体验音视频通话功能': 'TUICallKitをまだ統合していないため、音视频通話機能を体験できません',
  '请点击': 'クリックしてください',
  '集成TUICallKit': 'TUICallKitを統合する',
  '开通腾讯实时音视频服务': '騰訊のリアルタイム音视频サービスを開通する',
  '进行体验': '体験を行う',
  '您当前购买使用的套餐包暂未开通此功能': '現在購入使用している套餐包ではこの機能は開通していません',
  '系统消息': 'システムメッセージ',
  '转人工服务': '人工サービスに転送する',
  '点击处理': 'クリックして処理',
  '发送失败': '送信に失敗しました',
  '复制成功': 'コピーに成功しました',
  '回复': '返信',
  '回复详情': '返信の詳細',
  '拒绝': '拒否',
  '聊天记录': '[チャット履歴]',
  '内容包含敏感词汇': 'コンテンツには機密語句が含まれています',
  '您当前购买使用的套餐包暂未开通群消息已读回执功能': '現在ご利用のパッケージには、グループメッセージの既読通知機能がまだ開通されていません',
  '您当前购买使用的套餐包暂未开通在线用户列表功能': '現在ご利用のパッケージには、オンラインユーザーリスト機能がまだ開通されていません',
  '您有': 'あなたは',
  '涉及敏感内容': '機密内容に関連しています',
  '申请加入': '参加申請',
  '条回复': '件の返信',
  '条入群申请': '件のグループ参加申請',
  '同意': '同意',
  '图片消息失败,无效的图片格式': '画像メッセージが失敗しました、無効な画像形式です',
  '位置': '[位置]',
  '文件不存在,请检查文件路径是否正确': 'ファイルが存在しません、ファイルパスが正しいか確認してください',
  '文件大小超出了限制,如果上传文件,最大限制是100MB': 'ファイルサイズが制限を超えています、ファイルの最大制限は100MBです',
  '文件消息失败,禁止发送违规封禁的文件': 'ファイルメッセージが失敗しました、違反ファイルの送信は禁止されています',
  '无法查看': '表示できません',
  '无法收听': '聞くことができません',
  '正在加载': '読み込み中',
  '加载结束': '読み込み完了',
  '消息': '[メッセージ]',
  '消息或者资料中文本存在敏感内容,发送失败': 'メッセージまたはデータに機密内容が含まれているため、送信に失敗しました',
  '消息长度超出限制,消息长度不要超过12K': 'メッセージの長さが制限を超えています、メッセージの長さは12Kを超えないでください',
  '消息中图片存在敏感内容,发送失败': 'メッセージに機密内容のある画像が含まれているため、送信に失敗しました',
  '选择提醒的人': '通知する人を選択',
  '已过撤回时限': '撤回期限が過ぎました',
  '已拒绝': '拒否済み',
  '已同意': '同意済み',
  '引用失败': '引用に失敗しました',
  '翻译': '翻訳',
  '转文字': 'テキストに変換',
  '隐藏': '非表示',
  '腾讯云 IM': 'Tencent Cloud Chat',
  '空': '空です',
  '文本包含本地审核拦截词': 'テキストにはローカルの検閲ワードが含まれています',
  '按住说话': '押し続けて話す',
  '松开发送': '上げて送信',
  '松手取消': '上げてキャンセル',
  '录音结束提醒': '秒後に録音を自動停止',
  '语音播放失败': '音声の再生に失敗しました',
  '请检查麦克风访问权限': 'マイクのアクセス権限を確認してください',
  '按压时间过短，请按压超过1秒': '押す時間が短すぎます。1秒以上押してください',
  '正在录音': '録音中',
  '继续上滑可取消': '上にスワイプし続けるとキャンセルできます',
  '松开手指 取消发送': '指を離して送信をキャンセル',
  '此机型暂不支持复制功能': 'この機種ではコピー機能はサポートされていません',
  '请开通翻译功能': '翻訳機能を有効にしてください',
  '请开通语音转文字功能': '音声をテキストに変換する機能を有効にしてください',
  '翻译中': '翻訳中',
  '转换中': '変換中',
  '由IM提供翻译支持': 'IMが翻訳サポートを提供',
  '所有人': '全て',
  '已达到表情回应上限数量': '表情の反応の上限数に達しました',
  '等': 'など',
  '人': '人',
  '返回': '戻る',
  '关闭': '閉じる',
  '多选': '複数選択',
  '合并转发': '転送を結合',
  '逐条转发': '一つずつ転送',
  '未选择消息': 'メッセージが選択されていません',
  '[草稿]': '[下書き]',
  '[消息]': '[メッセージ]',
  '[文本]': '[テキスト]',
  '[自定义消息]': '[カスタムメッセージ]',
  '[图片]': '[画像]',
  '[音频]': '[音声]',
  '[语音]': '[音声]',
  '[视频]': '[ビデオ]',
  '[文件]': '[ファイル]',
  '[位置]': '[位置]',
  '[地理位置]': '[位置]',
  '[动画表情]': '[アニメステッカー]',
  '[群提示]': '[グループヒント]',
  '[群提示消息]': '[グループ通知]',
  '[聊天记录]': '[チャット履歴]',
  '[机器人自定义消息]': '[カスタムロボットメッセージ]',
  '引用内容已撤回': '引用された内容は取り消されました',
  '群聊的聊天记录': 'グループチャットのチャット履歴',
  '和': 'と',
  '的聊天记录': 'のチャット履歴',
  '请升级IMSDK到v2.10.1或更高版本查看此消息': 'このメッセージを表示するには、IMSDKをv2.10.1またはそれ以上のバージョンにアップグレードしてください',
  '该群聊已被解散': 'このグループチャットは解散されました',
  '您已被管理员移出群聊': '管理者によってグループチャットから削除されました',
  '您已退出该群聊': 'このグループチャットから退出しました',
  '您已被禁止聊天': 'チャットが禁止されています',
  '按Enter发送，Ctrl+Enter换行': 'Enterキーで送信、Ctrl+Enterキーで改行',
  '账号被强制下线': 'アカウントが強制的にログアウト',
  '登录失败': 'ログインに失敗しました',
  '链接':'[リンク]',
};

export default TUIChat;
